import { Link } from "react-router-dom";
import { LayoutGrid, ListChecks, MessageCircle, ArrowRight } from "lucide-react";
import { buildStockWhatsAppUrl } from "@/lib/whatsapp";

export function ActionTiles() {
  const waUrl = buildStockWhatsAppUrl();

  const tiles = [
    {
      icon: LayoutGrid,
      title: "Katalog Produk",
      desc: "Jelajahi semua platform dan paket dalam satu panel.",
      to: "/produk",
      testId: "action-katalog",
    },
    {
      icon: ListChecks,
      title: "Cara Beli",
      desc: "Pahami langkah pemesanan dari pilih paket sampai aktivasi.",
      to: "/cara-beli",
      testId: "action-cara-beli",
    },
    {
      icon: MessageCircle,
      title: "Cek Stok WhatsApp",
      desc: "Cek ketersediaan produk terbaru langsung melalui WhatsApp.",
      href: waUrl,
      testId: "action-bantuan",
    },
  ];

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {tiles.map(({ icon: Icon, title, desc, to, href, testId }) => {
          const inner = (
            <>
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-nm-red/10 text-nm-red">
                <Icon className="h-5 w-5" />
              </span>
              <h3 className="mt-4 flex items-center gap-1.5 text-base font-bold text-nm-text">
                {title}
                <ArrowRight className="h-4 w-4 text-nm-muted transition-transform group-hover:translate-x-0.5" />
              </h3>
              <p className="mt-1 text-sm text-nm-muted">{desc}</p>
            </>
          );
          const cls =
            "group rounded-2xl border border-nm-border bg-nm-surface p-6 transition-all duration-200 hover:-translate-y-0.5 hover:border-nm-red/40";
          return href ? (
            <a
              key={testId}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={testId}
              className={cls}
            >
              {inner}
            </a>
          ) : (
            <Link key={testId} to={to} data-testid={testId} className={cls}>
              {inner}
            </Link>
          );
        })}
      </div>
    </section>
  );
}
